import { FC } from 'react';
import { Badge } from '@chakra-ui/react';

import { ActivityCauserType } from '../../types';
import { ACTIVITY_CAUSER_BADGE_CONFIG } from './constants/activityCauser';
import { ActivityCauserBadgeProps } from './types/ActivityCauserBadgeProps';

export const ActivityCauserBadge: FC<ActivityCauserBadgeProps> = ({
  activityCauser = ActivityCauserType.System,
}) => {
  const { label, colorPalette } = ACTIVITY_CAUSER_BADGE_CONFIG[activityCauser];

  return (
    <Badge colorPalette={colorPalette} size="lg" textTransform="capitalize">
      {label}
    </Badge>
  );
};
